import axiosInstance from "../axiosInstance";

// Get all goals for a specific user (admin only)
export const getAdminUserGoalsAPI = async (userId) => {
  try {
    const response = await axiosInstance.get(`/goals/user/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Create a goal for a specific user (admin only)
export const createAdminUserGoalAPI = async (userId, goalData) => {
  try {
    const response = await axiosInstance.post(
      `/goals/user/${userId}`,
      goalData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update a goal by ID (admin can update any goal)
export const updateAdminGoalAPI = async (goalId, goalData) => {
  try {
    const response = await axiosInstance.put(`/goals/${goalId}`, goalData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Delete a goal by ID (admin can delete any goal)
export const deleteAdminGoalAPI = async (goalId) => {
  try {
    const response = await axiosInstance.delete(`/goals/${goalId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update a specific task completion status (admin can update any task)
export const updateAdminTaskStatusAPI = async (goalId, taskData) => {
  try {
    const response = await axiosInstance.put(`/goals/${goalId}/task`, taskData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
